import { Order } from "@/api/orders.api";
import { cn } from "@/lib/utils";

export interface CurrencyTotals {
  total: number;
  bill: number;
  tip: number;
  count: number;
}

export function getOrderId(order: Order): string {
  return order.mezzaOrderId;
}

export function getListBottomPadding(isCalculatorMode: boolean): string {
  return isCalculatorMode ? "pb-44" : "";
}

export function getCalculatorButtonStyles(isActive: boolean): string {
  return cn(
    "h-8 w-8 transition-colors",
    isActive && "bg-primary/10 text-primary"
  );
}

export function createEmptyCurrencyTotals(): CurrencyTotals {
  return {
    total: 0,
    bill: 0,
    tip: 0,
    count: 0,
  };
}

export function addOrderAmountsToTotals(totals: CurrencyTotals, order: Order): void {
  totals.total += order.amount + order.tipAmount;
  totals.bill += order.amount;
  totals.tip += order.tipAmount;
  totals.count += 1;
}
